var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [_c("form-template", { on: { save: _vm.onSave, cancel: _vm.onCancel } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }